import { Stack, Box } from '@mui/material';

import React from 'react';

import { ReactComponent as TableSortIcon } from 'common/assets/images/./table-sort-icon.svg';

import { ReactComponent as SortAscendingIcon } from 'common/assets/images/sort-asc-icon.svg';
import { ReactComponent as SortDescendingIcon } from 'common/assets/images/sort-desc-icon.svg';
import { toSentenceCase } from 'common/utils/utilFunctions';

import { Column } from './CommonTableStyles';

import styles from './CommonTable.module.scss';

// Define the props type for the component
type ISortableHeaderProps = {
	headCell: Column; // The label to display
	order: string; // The id of the column that is currently sorted
	orderBy: string; // The id of the column that is currently sorted
	fill: string; // The id of the column
};

// Define the component as a functional component
const CellComponent: React.FC<any> = (props: ISortableHeaderProps) => {
	const { headCell, orderBy, fill, order } = props;

	const getOrderIcon = (order: string) => {
		if (order === 'desc') {
			return <SortDescendingIcon fill={fill} />;
		}
		return <SortAscendingIcon fill={fill} />;
	};

	// Return the JSX element
	return (
		<Stack direction="row" spacing={1}>
			<Box component="span" className={styles['table-column-cell-col-label']}>
				{headCell?.hideSentenceCase
					? headCell?.label
					: toSentenceCase(headCell?.label)}{' '}
			</Box>

			{orderBy === headCell.id ? (
				<Box component="span">{getOrderIcon(order)}</Box>
			) : (
				<Box component="span">
					{' '}
					{headCell?.isSortable ? <TableSortIcon fill={fill} /> : null}
				</Box>
			)}
		</Stack>
	);
};

// Export the component
export default CellComponent;
